module.exports = __webpack_public_path__ + "static/media/b72985b7-18c7-4491-b382-5a701dd63590.f6a2c7c5.JPG";